import { render, staticRenderFns } from "./PixelManagerHome.vue?vue&type=template&id=8c091c02&"
import script from "./PixelManagerHome.vue?vue&type=script&lang=ts&"
export * from "./PixelManagerHome.vue?vue&type=script&lang=ts&"
import style0 from "./PixelManagerHome.vue?vue&type=style&index=0&id=8c091c02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports